import { render, staticRenderFns } from "./MeasureTypeEditor.vue?vue&type=template&id=14d8ed13&scoped=true"
import script from "./MeasureTypeEditor.vue?vue&type=script&lang=js"
export * from "./MeasureTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d8ed13",
  null
  
)

export default component.exports